'use client';

import { LinkProps } from '@unity/cloud-ui';
import { useTranslations } from 'next-intl';
import { NavigationLink } from '@/components/navigation-link';

export const Link = (props: LinkProps) => {
  const t = useTranslations();

  return (
    <NavigationLink
      aria-label={t('link:generic:aria-label', { title: props.href || '' })}
      {...props}
      href={props.href}
    />
  );
};
